import React from 'react';
import SpaSite from './SpaSite';

function App() {
  return (
    <div>
      <SpaSite />
    </div>
  );
}

export default App;
